<template>
  <div>
    <main-nav></main-nav>
    <sidebar></sidebar>
    <router-view :key="$route.path"></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import MainNav from "../components/Layouts/MainNav.vue";
import Sidebar from "../components/Layouts/Sidebar.vue";
import io from "socket.io-client";
import { hasFullOpsAccess } from "@/helpers/roles.js";

export default {
  name: "Home",

  components: { MainNav, Sidebar },

  data() {
    return {
      isLoading: true,
      socket: null,
    };
  },
  computed: {
    // START:: VUEX GET AUTHENTICATED USER DATA
    ...mapGetters("auth_module", ["currentUser"]),
    // END:: VUEX GET AUTHENTICATED USER DATA
    chats() {
      return this.$store.getters["chat_module/chats"];
    },
    user() {
      return this.$store.getters["auth_module/currentUser"];
    },
  },

  methods: {
    setMessage(payload) {
      var audio = document.createElement("AUDIO");
      document.body.appendChild(audio);
      // audio.src = require("@/assets/sounds/notification.wav");
      // audio.play();
      // this.$iziToast.show({
      //   title: this.$t("newMessage"),
      //   message: `${this.$t(payload.data.sender.user_type)}  ${this.$t(
      //     payload.data.sender.name
      //   )}`,
      //   balloon: true,
      //   displayMode: 2,
      //   timeout: 15000,
      // });
      let found = this.chats.find((el) => el.id == payload.data.id);
      if (found) {
        found.last_message = payload.data.message;
        found.last_message_created_at = payload.data.ago_time;
        found.last_message_created = new Date(
          payload.data.created_at
        ).getTime();
        found["is_read"] = payload.data.is_read;
      }

      const userType = payload.data?.sender?.user_type;
      let routePath = "/chats/client";
      if (userType === "driver") {
        routePath = "/chats/driver";
      } else if (
        userType === "restaurant" ||
        userType === "resturant" ||
        userType === "store"
      ) {
        routePath = "/chats/resturant";
      }

      if (payload.data.message_type == "complaint") {
        audio.src = require("@/assets/sounds/complaint.wav");
        audio.play();
        this.$swal({
          title: this.$t("newComplaint"),
          text: `${this.$t(payload.data.sender.user_type)}  ${this.$t(
            payload.data.sender.name
          )}`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: this.$t("cancel"),
          confirmButtonText: this.$t("show"),
        }).then((result) => {
          if (result.isConfirmed) {
            this.$router.push(routePath).catch(() => {});
          }
        });
      } else {
        audio.src = require("@/assets/sounds/notification.wav");
        audio.play();
        this.$iziToast.show({
          title: this.$t("newMessage"),
          message: `${this.$t(payload.data.sender.user_type)}  ${this.$t(
            payload.data.sender.name
          )}`,
          balloon: true,
          displayMode: 2,
          timeout: 15000,
          onClick: (instance, toast) => {
            instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            this.$router.push(routePath).catch(() => {});
          },
        });
      }
    },
    exportData() {
      this.$axios({
        method: "post",
        url: "meal/download-export",
        responseType: "blob", // أهم نقطة
      })
        .then(async (res) => {
          // لو السيرفر أرسل JSON خطأ بدل ملف
          if (res.data.type === "application/json") {
            const text = await res.data.text();
            const { message } = JSON.parse(text);
            this.$iziToast.error({
              title: this.$t("validation.error"),
              message,
            });
            return;
          }

          // اسم الملف من الهيدر (اختياري)
          const dispo = res.headers["content-disposition"] || "";
          const match = dispo.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
          const today = new Date();
          const day = String(today.getDate()).padStart(2, "0");
          const month = String(today.getMonth() + 1).padStart(2, "0");
          const year = today.getFullYear();
          const dateStr = `${day}/${month}/${year}`;
          const filename = match
            ? decodeURIComponent(match[1].replace(/['"]/g, ""))
            : `meals-${dateStr}.csv`;

          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet/csv",
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.setAttribute("download", filename);
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          const message =
            err.response?.data?.message ??
            err.response?.data?.messages ??
            err.message;
          this.$iziToast.error({ title: this.$t("validation.error"), message });
        });
    },
    allChatSoket() {
      const userId = localStorage.getItem("zoz_dash_User_Id");

      if (!this.socket) {
        this.socket = io(`${process.env.VUE_APP_BASE_URL_SOCKET}:3073`);
      }
      const socket = this.socket;

      // Ensure we don't accumulate duplicate listeners
      socket.off("NewSupportChat");
      if (userId) socket.off(`AdminNotification:${userId}`);

      socket.on("NewSupportChat", (payload) => {
        if (payload) {
          this.setMessage(payload);
        }
      });

      socket.on(`AdminNotification:${userId}`, (payload) => {
        if (!payload) return;

        var audio = document.createElement("AUDIO");
        document.body.appendChild(audio);
        audio.src = require("@/assets/sounds/notification.wav");
        audio.play();

        this.$store.dispatch("notifications_module/getUnreadNotifCount");
        console.log(payload, "test not");

        if (payload.notify_type == "download_meals") {
          this.exportData();
          this.$store.dispatch("notifications_module/getNotifications");
        }

        if (payload.notify_type == "admin_request_withdraw") {
          if (this.$route.name == "AllTransactions") {
            location.reload();
          }
          // this.$store.dispatch("notifications_module/getNotifications");
        }

        if (payload.notify_type == "payout_batch_finished") {
          location.reload();
        }
        console.log(payload.title, "==============");

        this.$iziToast.show({
          title: payload.title,
          message: payload.body,
        });
      });
    },
    getPermissions() {
      return this.$axios
        .get("my_permissions")
        .then((res) => {
          const data = res.data?.data || [];
          localStorage.setItem("Zoz_permissions", JSON.stringify(data));
          this.$store.commit("setPermissions", data);
          return data;
        })
        .catch((err) => {
          if (err.response?.status === 422) {
            localStorage.setItem("Zoz_permissions", JSON.stringify([]));
            this.$store.commit("setPermissions", []);
          }
          return [];
        });
    },
    getControls() {
      return this.$axios
        .get("my_permissions")
        .then((res) => {
          const data = res.data?.data || [];
          localStorage.setItem("Zoz_controls", JSON.stringify(data));
          return data;
        })
        .catch((err) => {
          if (err.response?.status === 422) {
            localStorage.setItem("Zoz_controls", JSON.stringify([]));
          }
          return [];
        });
    },
    launch_resize_dispatch() {
      this.$store.dispatch("sideNav_module/onResize");
    },
  },

  mounted() {
    this.allChatSoket();
    if (!hasFullOpsAccess(this.$store)) {
      this.getPermissions();
      this.getControls();
    } else {
      if (localStorage.getItem("Zoz_controls")) {
        localStorage.removeItem("Zoz_controls");
      }
      if (localStorage.getItem("Zoz_permissions")) {
        localStorage.removeItem("Zoz_permissions");
      }
    }
    this.$store.dispatch("chat_module/getChats");
    // ===> check if the page is login
    this.launch_resize_dispatch();
    if (this.$store.getters.resizeEventExisit == false) {
      window.addEventListener("resize", this.launch_resize_dispatch, true);
      this.$store.commit("changeRessizeEvent");
    }
  },

  beforeDestroy() {
    if (this.socket) {
      const userId = localStorage.getItem("zoz_dash_User_Id");
      this.socket.off("NewSupportChat");
      if (userId) this.socket.off(`AdminNotification:${userId}`);
      this.socket.close();
      this.socket = null;
    }
  },
};
</script>
